/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartPriceTable_user$ref = any;
export type CartItemPricing_user$ref = any;
export type CartItemPricing_user = {
    readonly " $fragmentRefs": CartPriceTable_user$ref;
    readonly " $refType": CartItemPricing_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemPricing_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "CartPriceTable_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '939e259b93e930bc69c22e2e4c0de910';
export default node;
